export default __webpack_public_path__ + "static/media/grocery-store.f6566065.png";